import React from 'react';
import { createPortal } from 'react-dom';
import { Button, Select, Text } from '@vymo/ui/atoms';
import styles from './index.module.scss';

type Platform = 'ios' | 'android' | 'web' | 'selfserve';

interface ViewportIndicatorProps {
  platform: Platform;
  width: number;
  height: number;
  setPlatform: (platform: Platform) => void;
  onChangeApp?: () => void;
}

const PLATFORM_OPTIONS: Platform[] = ['ios', 'android', 'web', 'selfserve'];

function ViewportIndicator({
  platform,
  setPlatform,
  width,
  height,
  onChangeApp,
}: ViewportIndicatorProps): JSX.Element {
  const handlePlatformChange = (selectedOptions) => {
    if (selectedOptions.length > 0 && selectedOptions[0].value) {
      const newPlatform = selectedOptions[0].value as Platform;
      localStorage.setItem('mock_platform_type', newPlatform);
      setPlatform(newPlatform);
    }
  };

  const options = PLATFORM_OPTIONS.map((option) => ({
    label: option.toUpperCase(),
    value: option,
  }));

  const isMobilePlatform = platform === 'ios' || platform === 'android';

  return createPortal(
    <div className={styles.viewportIndicator}>
      <div className={styles.viewportIndicator__content}>
        <Select
          placeholder="Select Platform"
          value={platform}
          onChange={handlePlatformChange}
          options={options}
          multi={false}
          classNames={styles.viewportIndicator__select}
        />

        <Text
          classNames={styles.viewportIndicator__dimensions}
          variant="default"
        >
          {width} × {height}
        </Text>
        <Button
          type="outlined"
          variant="default"
          size="small"
          onClick={() => {
            const relativePath = `src/modules/mockHostApp/hostAppInterface/${platform}.ts`;
            const absolutePath = `${process.env.APP_DIRECTORY}/${relativePath}`;
            window.open(`vscode://file/${absolutePath}`);
          }}
        >
          Edit HostApp Signature
        </Button>
        {isMobilePlatform && onChangeApp && (
          <Button size="small" onClick={onChangeApp}>
            Change App
          </Button>
        )}
      </div>
    </div>,
    document.body,
  );
}

export default ViewportIndicator;
